import React from "react";
import "./tableRanking.scss";
import useFormatParties from "../../dataProvider/hooks/useFormatParties";
const COMPARE_MUNICIPALITIES = new Set(["28079", // Madrid
"08019", // Barcelona
"08015", // Badalona
"08101", // L'Hospitalet
"08187", // Sabadell
"48020", // Bilbao
"11012", // Cádiz
"35016", // Las Palmas de Gran Canaria
"29067", // Málaga
"29069", // Marbella
"30030", // Murcia
"07040", // Palma de Mallorca
"20069", // San Sebastián
"41091", // Sevilla
"46250", // Valencia
"47186", // Valladolid
"01059", // Vitoria
"50297", // Zaragoza
"15078", // Santiago de Compostela
"15030", // A Coruña
"36057", // Vigo
"45168" // Toledo
]);

const TableRanking = ({
  currentData,
  pastData,
  place,
  year,
  electionNumber,
  electionType,
  placeId,
  titleColumn,
  titleColumn2
}) => {
  const partyFormats = useFormatParties(currentData, pastData, year, electionNumber, electionType, placeId);

  if (!partyFormats) {
    return React.createElement("div", null, "Loading");
  }

  const isValid = !place ? true : COMPARE_MUNICIPALITIES.has(place);
  const partiesResult = partyFormats.filter(item => item.seats);
  return React.createElement("div", {
    className: "tableRankingScrollContent"
  }, React.createElement("div", {
    className: "tableRankingScroll"
  }, React.createElement("div", {
    className: "tableRanking"
  }, React.createElement("table", {
    summary: "Esca\xF1os por partido."
  }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", {
    className: "partido"
  }), React.createElement("th", {
    className: "year year_current"
  }, titleColumn), isValid && React.createElement("th", {
    className: "year year_last"
  }, titleColumn2))), React.createElement("tbody", null, partyFormats && partiesResult && partiesResult.map(party => React.createElement("tr", {
    key: party.id
  }, React.createElement("td", {
    className: "partyName",
    style: {
      backgroundColor: party.partyColor
    }
  }, React.createElement("h3", {
    className: "partyName_title"
  }, "".concat(party.partyAcronym).concat(party.id === 43 ? " *" : ""))), React.createElement("td", {
    className: "partySeats partySeats_current"
  }, party.seats), isValid && React.createElement("td", {
    className: "partySeats partySeats_old"
  }, React.createElement("span", {
    className: party.symbolClassName
  }, Math.abs(party.difference))))))))), React.createElement("p", {
    className: "table-legend"
  }, "*Los datos de PP y Cs (0 esca\xF1os) se representan sumados en 2016"));
};

export default TableRanking;